import { createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-759cfd26")

_pushScopeId("data-v-759cfd26")
const _hoisted_1 = { class: "bg-ff table-content" }
const _hoisted_2 = { class: "flex alignC top-button-group" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8 mar-l-16" }, "日期", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8 mar-l-16" }, "项目", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8 mar-l-16" }, "部门", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8 mar-l-16" }, "施工人", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("仅显示单项提成")
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "导出", -1)
const _hoisted_9 = { class: "flex flexR mar-t-22" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_el_date_picker, {
        modelValue: _ctx.screenParameter.time,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.screenParameter.time = $event)),
        type: "daterange",
        align: "right",
        "unlink-panels": "",
        "range-separator": "-",
        "start-placeholder": "开始日期",
        "end-placeholder": "结束日期",
        shortcuts: _ctx.shortcuts,
        onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.screenChange($event, 'time')))
      }, null, 8, ["modelValue", "shortcuts"]),
      _hoisted_4,
      _createVNode(_component_el_select, {
        class: "mar-r-8",
        style: {"width":"108px"},
        modelValue: _ctx.screenParameter.project_id,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.screenParameter.project_id = $event)),
        onChange: _ctx.selectChange,
        placeholder: "请选择",
        clearable: "",
        filterable: ""
      }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.project, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: index,
              label: item.name,
              value: item.id
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "onChange"]),
      _hoisted_5,
      _createVNode(_component_el_select, {
        class: "mar-r-8",
        style: {"width":"108px"},
        modelValue: _ctx.screenParameter.branch_id,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.screenParameter.branch_id = $event)),
        onChange: _ctx.selectChange,
        placeholder: "请选择",
        clearable: ""
      }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.branch, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: index,
              label: item.name,
              value: item.id
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "onChange"]),
      _hoisted_6,
      _createVNode(_component_el_select, {
        class: "mar-r-8",
        style: {"width":"108px"},
        modelValue: _ctx.screenParameter.constructor_id,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.screenParameter.constructor_id = $event)),
        onChange: _ctx.selectChange,
        placeholder: "请选择",
        clearable: "",
        multiple: ""
      }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.staff, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: index,
              label: item.nickname,
              value: item.id
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "onChange"]),
      _createVNode(_component_el_checkbox, {
        modelValue: _ctx.screenParameter.status,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.screenParameter.status = $event)),
        class: "mar-r-8",
        "true-label": "1",
        "false-label": "2",
        onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectChange()))
      }, {
        default: _withId(() => [
          _hoisted_7
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "mar-l-16 mar-r-18 mar-t-12",
        modelValue: _ctx.screenParameter.search,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.screenParameter.search = $event)),
        placeholder: "工单号/车牌号/项目",
        "suffix-icon": "el-icon-search",
        style: {"width":"220px"},
        clearable: "",
        onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectChange($event)))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "bg-red mar-t-12",
        onClick: _ctx.exportChange
      }, {
        default: _withId(() => [
          _hoisted_8
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode("div", null, [
      _withDirectives(_createVNode(_component_el_table, {
        data: _ctx.tableData,
        stripe: "",
        style: {"width":"100%"},
        class: "table",
        "show-summary": "",
        "summary-method": _ctx.getSummaries,
        "header-cell-style": _ctx.headClass
      }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columnList, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_table_column, {
              align: "center",
              prop: item.prop,
              label: item.label,
              "min-width": item.width,
              key: index
            }, null, 8, ["prop", "label", "min-width"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["data", "summary-method", "header-cell-style"]), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _createVNode("div", _hoisted_9, [
      _createVNode(_component_el_pagination, {
        onSizeChange: _ctx.handleSizeChange,
        onCurrentChange: _ctx.handleCurrentChange,
        "current-page": _ctx.screenParameter.page,
        "page-sizes": [10, 20,50,100],
        "page-size": _ctx.screenParameter.pagesize,
        layout: "total, sizes, prev, pager, next, jumper",
        total: _ctx.total
      }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
    ])
  ]))
})